$(document).ready(function () {
    // currency comme sur peps
    $(".transformMontantEuro").each(function () {
        $(this).html(new Intl.NumberFormat('fr-FR').format($(this).html()));
    });
});


